<div
  class="int-input"
  #rootElement
  [class]="[
  focused ? '_focused' : '_blur',
   value ? '_not-empty' : '_empty'
 ]"
>
    <div class="int-input__cols-wrap" #colswrap>
        <div class="int-input__box-column">
            <ng-content select="left-position"></ng-content>
        </div>
        <div
            class="int-input__field-column"
            *ngIf="{
            data: (value$ | async),
            dir: (dir$ | async)
            } as streams$"
        >
            <div class="int-input__label" [class]="'int-input__label--' + streams$.dir" *ngIf="!isNotLabelOrPlaceholder && showLabelTip">
                {{ currentLabel }}
            </div>
            <input
                #field
                class="int-input__field"
                [class.hide]="hideField"
                [type]="type"
                [value]="streams$.data"
                [disabled]="disabled"
                (input)="changeValue($event)"
                (focus)="onFocus()"
                (blur)="onBlur()"
                [placeholder]="currentLabel"
                [readonly]="readonly"
                [autocomplete]="autocomplete"
            />
        </div>
        <div class="int-input__box-column">
            <ng-content select="right-position"></ng-content>
        </div>
    </div>
    <div class="bottom">
        <ng-content select="bottom-position"></ng-content>
    </div>
</div>
